import React from 'react';
import { Section, Header } from 'components';
import { Col, Row  } from 'react-bootstrap';

import styles from './GettingStarted.module.css';
import { useTranslation } from 'react-i18next';
import { GettingStartedCard } from './GettingStartedCard';

type GettingStartedProps = {}

export const GettingStarted: React.FC<GettingStartedProps> = React.memo(() => {
  const { t } = useTranslation();
  return (
    <Section>
      <Header className={styles.header} noBackground>
        <Col xs="12" className="col-lg-12"><h2>{t('getting-started')}</h2></Col>
      </Header>
      <Row className={styles.gsInfoCard}>
        <Section>
          <Row><h3>{t('getting-started-info-title')}</h3></Row>
          <Row><p>{t('getting-started-info')}</p></Row>
        </Section>
      </Row>
      <Row>
        <GettingStartedCard />
      </Row>
    </Section>
  )
});
